exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overview-header {\n  border-bottom: 1px solid #c9c9c9;\n  margin-bottom: 5px;\n}\n\n.overview-header > h4 {\n  margin: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/src/app/dashboard.component.css
// module id = ../../../../../src/app/dashboard.component.css
// module chunks = main